import { sendSumoLog } from './sumoLogger';
import { updateCurContact, updateError } from '../../stores/notifications';

export const fetchContact = async (
  token,
  dispatch,
  userId,
  immediate = false
) => {
  const requestURL = encodeURI(
    `https://${process.env.REACT_APP_API_SUBDOMAIN}.pge-811.com/ticket-notification/users/${userId}.json`
  );
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
  });
  try {
    const data = await fetch(requestURL, {
      method: 'GET',
      headers,
    });
    if (!data.ok) {
      const message = `Ticket notification contact ${userId} GET failed: ${data.status}`;
      const errorCode = data.status;
      throw {
        message,
        errorCode,
      };
    }

    const curContact = await data.json();
    // console.log('fetchContact - jsonData: ', curContact);
    if (immediate) {
      return curContact;
    }

    updateCurContact(curContact, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'fetchContact';
    const errorCode = isInternalError ? 500 : error.errorCode;
    sendSumoLog(errorType, error.message, errorCode, dispatch);
    updateError(error, dispatch);
    return null;
  }
};
